import { c as _c } from "react/compiler-runtime";
import { RefObject } from 'react';
import Turnstile, { TurnstileRef } from './Turnstile';
import { useTurnstile } from '@/hooks/useTurnstile';
import { FieldError } from './FieldGroup.js';
import styles from './TurnstileField.module.scss';
interface TurnstileFieldProps {
  formik: {
    errors: Record<string, string | undefined>;
    touched: Record<string, boolean | undefined>;
    setFieldValue: (field: string, value: string, shouldValidate?: boolean) => void;
    setFieldError: (field: string, message: string) => void;
    setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void;
  };
  ref: RefObject<TurnstileRef | null>;
}
export default function TurnstileField(t0) {
  const $ = _c(12);
  const {
    formik,
    ref
  } = t0;
  const {
    siteKey,
    onVerify,
    onError,
    onExpire
  } = useTurnstile(formik);
  let t1;
  if ($[0] !== onError || $[1] !== onExpire || $[2] !== onVerify || $[3] !== ref || $[4] !== siteKey) {
    t1 = <Turnstile ref={ref} siteKey={siteKey} onVerify={onVerify} onError={onError} onExpire={onExpire} />;
    $[0] = onError;
    $[1] = onExpire;
    $[2] = onVerify;
    $[3] = ref;
    $[4] = siteKey;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== formik.errors.turnstileToken || $[7] !== formik.touched) {
    t2 = formik.errors.turnstileToken && formik.touched.turnstileToken && <FieldError>{formik.errors.turnstileToken}</FieldError>;
    $[6] = formik.errors.turnstileToken;
    $[7] = formik.touched;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={styles.turnstile}>{t1}{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}